import { render, staticRenderFns } from "./Send2.vue?vue&type=template&id=26c69edb&"
import script from "./Send2.vue?vue&type=script&lang=js&"
export * from "./Send2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports